import { application } from "./application"

// Eager load all Stimulus controllers from this directory
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })

for (const path in controllers) {
  const module = controllers[path]
  // Convert path to controller identifier: ./sidebar_controller.js → sidebar
  const identifier = path
    .replace("./", "")
    .replace("_controller.js", "")
    .replace(/_/g, "-")
    .replace(/\//g, "--")

  if (module.default) {
    application.register(identifier, module.default)
  }
}
